import { useGetUsersQuery } from "features/core/users/usersApiSlice";
import { useGetHealthProfilesQuery } from "features/health/profiles/api/healtProfilesApiSlice";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetHealthPatientsQuery } from "../api/healthPatientsApiSlice";

const HealthPatientForm = ({ initialData = {}, onSave, onCancel, isEditMode = false }) => {

    const [t] = useTranslation(["global", "health"])

    const [formData, setFormData] = useState({
        gender: initialData.gender || '',
        weight: initialData.weight || '',
        height: initialData.height || '',
        birthDate: initialData.birthDate
            ? new Date(initialData.birthDate * 1000).toISOString().split("T")[0]
            : '',
        healthProfileGuid: initialData.healthProfile?.guid || null,
        userGuid: initialData.userGuid || '', // usato solo in creazione
    });

    const { data: profiles, isSuccess: profilesSuccess } = useGetHealthProfilesQuery();
    const { data: patients, isFetching, isSuccess, refetch } = useGetHealthPatientsQuery();
    const { data: users, isSuccess: usersSuccess } = useGetUsersQuery();

    const usersWithoutPatientProfile = useMemo(() => {
        if (!users || !patients) return [];

        // Creiamo un set con tutti gli userGuid presenti nei pazienti
        const patientUserGuids = new Set(
            patients.map(p => p.user?.guid)
        );
        console.log("Utenti con profilo Patinet: " + JSON.stringify(Array.from(patientUserGuids)))

        // Filtriamo gli utenti che NON compaiono nei pazienti
        let filtered = users.filter(u => !patientUserGuids.has(u.guid));
        console.log("Utenti senza un profilo Patient: " + JSON.stringify(filtered))
        return filtered
    }, [users, patients]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            gender: formData.gender,
            weight: parseFloat(formData.weight),
            height: parseFloat(formData.height),
            birthDate: Math.floor(new Date(formData.birthDate).getTime() / 1000),
        };

        if (formData.healthProfileGuid) {
            payload.healthProfileGuid = formData.healthProfileGuid;
        }

        if (formData.userGuid) {
            payload.userGuid = formData.userGuid;
        }

        onSave(payload);
    };

    return (
        <form onSubmit={handleSubmit} className="card bg-dark text-white p-3">
            <div className="card-body">

                <div className="mb-2 row">
                    <div className="col-7">
                        <label>{t("health:entity.patient.props.name")}</label>
                        {isEditMode ?

                            <input
                                type="text"
                                className="form-control disabled"
                                value={initialData.userDisplayName}
                                disabled={true}
                            />

                            :
                            <select
                                name="userGuid"
                                className="form-control"
                                value={formData.userGuid}
                                onChange={handleChange}
                            >
                                <option value="">{t("health:helper.select_patient")}</option>
                                {usersWithoutPatientProfile.map(user => (
                                    <option key={user.guid} value={user.guid}>{user.displayName}</option>
                                ))}
                            </select>

                        }
                    </div>
                    <div className="col-5">
                        <label>{t("health:entity.patient.props.gender")}</label>
                        <select
                            name="gender"
                            className="form-control"
                            value={formData.gender}
                            onChange={handleChange}
                            required
                        >
                            <option value="">-</option>
                            <option key="MALE" value="MALE">{t("health:entity.patient.gender.MALE")}</option>
                            <option key="FEMALE" value="FEMALE">{t("health:entity.patient.gender.FEMALE")}</option>

                        </select>
                    </div>

                </div>

                <div className="row my-4">
                    <div className="col-3">
                        <label>{t("health:entity.patient.props.weight")} <small className="text-muted">kg</small></label>
                        <input name="weight" type="number" className="form-control" value={formData.weight} onChange={handleChange} />
                    </div>
                    <div className="col-4">
                        <label>{t("health:entity.patient.props.height")} <small className="text-muted">cm</small></label>
                        <input name="height" type="number" className="form-control" value={formData.height} onChange={handleChange} />
                    </div>
                    <div className="col-5">
                        <label>{t("health:entity.patient.props.birthday")}</label>
                        <input
                            name="birthDate"
                            type="date"
                            className="form-control date-picker"
                            value={formData.birthDate}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-4">
                        <label>{t("health:entity.profile.props.name")}</label>
                        <select name="healthProfileGuid" className="form-control" value={formData.healthProfileGuid || ''} onChange={handleChange}>
                            <option value="">Default</option>
                            {profilesSuccess && profiles.filter(profile => !profile.profile.isDefault).map(profile => (
                                <option key={profile.profile.guid} value={profile.profile.guid}>{profile.profile.name}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="text-end mt-4">
                    <button type="submit" className="btn btn-primary mx-1">{t("action.save")}</button>
                    <button type="button" className="btn btn-secondary" onClick={onCancel}>{t("action.cancel")}</button>
                </div>
            </div>
        </form>
    );
};


export default HealthPatientForm
